import PageNotFound from "@/components/PageNotFound";
import GovernmentWebsiteInfo from "@/Features/AapleSarkar";
import MetaTagsUpdater from "@/Features/MetaTagUpdater";
import { AccessibilityStatement } from "@/Layouts/Footer/screens/AccessibilityStatement";
import { AapleSarkarDashboardCount, DashboardPage } from "@/Pages/Dashboard";
import {
  HundredDaysProgram,
  ImportantGR,
  RtsList
} from "@/Pages/EcitizenPages";
import { FeedbackPage } from "@/Pages/Feedback";
import {
  FooterContact,
  HelpSection,
  Sitemap,
  WebinfoManager,
  WebsitePolicies,
} from "@/Pages/Footer";
import { Route, Routes } from "react-router-dom";
import MainLayout from "../Layouts/MainLayout";
import { History } from "../Pages/AboutUsPage";
import { CitizenCharter } from "../Pages/CitizenCharterPage";
import { ContactPage } from "../Pages/ContactPage";
import { Home } from "../Pages/HomePage";
import { PhotoGallery } from "../Pages/PhotoGalleryPage";
import { ProgramAndScheme } from "../Pages/ProgramAndScheme";
import { ScreenReaderAccess } from "../Pages/ScreenReaderAccess";
import { ShowECitizenDataTable } from "../Pages/ShowECitizenDataTablePage";
import { Subjects } from "../Pages/SubjectsPage";

const ApplicationRoutes = () => {
  return (
    <>
      <MetaTagsUpdater />
      <Routes>
        <Route element={<MainLayout />}>
          <Route path="/" element={<Home />} />
          <Route path="/history" element={<History />} />
          <Route path="/user_citizen_charter" element={<CitizenCharter />} />
          <Route path="/contact" element={<ContactPage />} />
          <Route path="/screen_reader" element={<ScreenReaderAccess />} />
          <Route path="/photo_gallery" element={<PhotoGallery />} />
          {/* <Route path="/showData/:data/:id" element={<ShowDataSubjects />} /> */}
          {/* <Route path="/subjects" element={<Subjects />} /> */}
          {/* <Route path="/showECitizen" element={<ShowECitizenDataTable />}>
            <Route path="acts_rules" element={<ActsRules />} />
            <Route
              path="important_government_resolution"
              element={<ImportantGR />}
            />
            <Route path="notifications" element={<Notifications />} />
            <Route path="user_manual" element={<UserManual />} />
            <Route
              path="right_to_information"
              element={<RightToInformation />}
            />
            <Route path="application_forms" element={<ApplicationForm />} />
            <Route path="minutes_meeting" element={<MinutesOfMeeting />} />
            <Route
              path="budgetary_provision"
              element={<BudgetaryProvision />}
            />
            <Route
              path="grievance_redressal"
              element={<GrievanceRedressal />}
            />
            <Route path="100_days_program" element={<HundredDaysProgram />} />
          </Route> */}
          <Route
            path="/showECitizen/:data/:id"
            element={<ShowECitizenDataTable />}
          />
          <Route
            path="/showECitizen/important_government_resolution"
            element={<ImportantGR />}
          />
          <Route path="/showECitizen/100_days_program" element={<HundredDaysProgram />} />
          <Route path="/programs&schemes" element={<ProgramAndScheme />} />
          <Route path="right_to_service" element={<RtsList />} />
          <Route path="/feedback" element={<FeedbackPage />} />
          <Route path="/accessibility_statement" element={<AccessibilityStatement />} />
          <Route path="/dashboard" element={<DashboardPage />} />
          <Route path="/aaple_sarkar_dashboard_count" element={<AapleSarkarDashboardCount />} />

          {/* Footer Screens */}
          <Route path="/policies" element={<WebsitePolicies />} />
          <Route path="/contact_us" element={<FooterContact />} />
          <Route path="/sitemap" element={<Sitemap />} />
          <Route path="/web_info_manager" element={<WebinfoManager />} />
          <Route path="/help" element={<HelpSection />} />
          <Route path="/aaple_sarkar" element={<GovernmentWebsiteInfo />} />
        </Route>
        <Route path="*" element={<PageNotFound />} />
      </Routes>
    </>
  );
};

export default ApplicationRoutes;
